import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import { retailerService } from "../../Services/retailerService";
import Loader from "../../Components/Loader";
import { PhoneCode } from "../../Components/PhoneCode";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { customerServiceService } from "../../Services";
import csc from "country-state-city";
import helperFunction from "../../Function/helperFunction";

const retailerTypeList = [
  { value: "electronics", label: "Electronics" },
  { value: "home_furnishing", label: "Home Furnishing" },
  { value: "toy_store", label: "Toy Store" },
  { value: "carpet", label: "Carpet" },
  { value: "sports_goods", label: "Sports Goods" },
  { value: "e_commerce", label: "E Commerce" },
  { value: "department_stores", label: "Department Stores" },
  { value: "fashion", label: "Fashion" },
  { value: "footwear", label: "Footwear" },
  { value: "general", label: "General" },
];

// const reg = /^(?=.*[aA-zZ])(?=.*[0-9])/

export const AddRetailer = () => {
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const [togglePassword, setTogglePassword] = useState(false);
  const [toggleStorePassword, setToggleStorePassword] = useState(false);
  const [customerServiceList, setCustomerServiceList] = useState([]);
  const [country, setCountry] = useState(csc.getAllCountries());
  const [countryCode, setCountryCode] = useState("");
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [storeCountryData, setStoreCountryData] = useState([]);

  // incentive: "",
  // contact_person: "",
  // taxation_details: "",
  // retailer_password: "",

  const initialValues = {
    type: "",
    profit_margin: "freight",
    retailer_name: "",
    retailer_type: "",
    address: "",
    country: "",
    state: "",
    city: "",
    postal_code: "",
    sales_person: "",
    designation: "",
    phone_number: "",
    retailer_email: "",
    vat_no: "",
    total_discount: "",
    customer_discount: "",
    store_discount: "",
    region: "",
    referral_token: "",
    // designation: "",
    contact_name: "",
    retailer_password: "",
    store: [],
  };

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Required"),
    retailer_name: Yup.string().required("Required"),
    retailer_type: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    country: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    sales_person: Yup.string().required("Required"),
    designation: Yup.string().required("Required"),
    phone_number: Yup.string()
      .required("Required")
      .min(10, "Minimum 10 digit contact no.")
      .max(12, "Maximum 12 digit contact no."),
    retailer_email: Yup.string().required("Required"),
    contact_name: Yup.string().required("Required"),
    retailer_password: Yup.string()
    .min(8, "Minimum 8 Digit Password")
    .required("Required"),
    region: Yup.string().required("Required"),
    referral_token: Yup.string()
    .required("Required")
    .min(3, "Minimum 3 Length referral code.")
    .max(7, "Maximum 7 Length referral code."),
    // total_discount: Yup.string().required("Required"),
    // customer_discount: Yup.string().required("Required"),
    // store_discount: Yup.string().required("Required"),
    vat_no: Yup.string().required("Required").max(15, "Maximum 15 characters"),
    
    // vat_no: Yup.string().when("type", {
    //   is: (type) => type === "marketplace",
    //   then: (schema) => schema.required("Vat no. is required").max(15, "Maximum 15 characters"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    total_discount: Yup.string().when("type", {
      is: (type) => type !== "marketplace",
      then: (schema) => schema.required("Total Discount is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    customer_discount: Yup.string().when("type", {
      is: (type) => type !== "marketplace",
      then: (schema) => schema.required("Customer Discount is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    store_discount: Yup.string().when("type", {
      is: (type) => type !== "marketplace",
      then: (schema) => schema.required("Store Discount is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // .matches(
    // 	/^(?=.*[A-Z])(?=.*[0-9])/,
    // 	"Must Contain 4 Uppercase Latter And,Three Number "
    // ),

    // designation: Yup.string().required("Required"),
    store: Yup.array().of(
      Yup.object().shape({
        store_email: Yup.string().required("Required"),
        store_name: Yup.string().required("Required"),
        store_password: Yup.string().required("Required"),
        contact_person: Yup.string().required("Required"),
        address: Yup.string().required("Required"),
        country: Yup.string().required("Required"),
        state: Yup.string().required("Required"),
        city: Yup.string().required("Required"),
        phone_number: Yup.string().required("Required"),
        store_designation: Yup.string().required("Required"),
      })
    ),
  });

  useEffect(() => {
    getCustomerService();
    // eslint-disable-next-line
  }, []);

  // const getItemList = () => {
  //   customerServiceService.CustomerServiceList().then((res) => {
  //     if (res.status) {
  //       let arr = [];
  //       for (let i = 0; i < res.data.length; i++) {
  //         if (res.data[i].department === "SALES") {
  //           arr.push({
  //             ...res.data[i],
  //             value: res.data[i].employee_name,
  //             label: res.data[i].employee_name,
  //           });
  //         }
  //       }
  //       setCustomerServiceList(arr);
  //     }
  //   });
  // };

  const getCustomerService = () => {
    let param = { role: "sales" };
    customerServiceService.getCustomerService(param).then((res) => {
      if (res.status) {
        let arr = [];
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].employee_name) {
            arr.push({
              ...res.data[i],
              value: res.data[i]?.employee_name,
              label: res.data[i]?.employee_name,
            });
          }
        }
        setCustomerServiceList(arr);
      }
    });
  };

  const onSubmit = (fields) => {
    setLoader(true);
    let postData = {
      ...fields,
      retailer_email: fields.retailer_email.toLowerCase(),
      postalcode: fields.postal_code,
    };
    if (postData.type === "marketplace") {
      delete postData.total_discount;
      delete postData.customer_discount;
      delete postData.store_discount;
    } else {
      delete postData.profit_margin;
    }
    retailerService.addRetailer(postData).then((res) => {
      if (res.status) {
        history.push("/retailer-list");
        toast.success(res.message);
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onSelect = (e, values, setValues, name) => {
    setValues({
      ...values,
      [name]: e.value,
    });
  };

  const addStore = (errors, values, setValues) => {
    const store = [...values.store];

    const {
      type,
      retailer_type,
      retailer_name,
      address,
      sales_person,
      designation,
      vat_no,
      retailer_email,
      phone_number,
      total_discount,
      customer_discount,
      incentive,
      contact_person,
      region,
      referral_token,
      // designation,
      store_discount,
      contact_name,
      retailer_password,
    } = values;

    if (errors && errors.store !== undefined) {
      toast.error("fill initial Store data");
    } else {
      store.push({
        store_email: "",
        store_name: "",
        store_designation: "",
        contact_person: "",
        phone_number: "",
        address: "",
        country: "",
        state: "",
        city: "",
        postal_code: "",
        store_password: "",
      });
      setValues({
        type,
        retailer_type,
        retailer_name,
        address,
        sales_person,
        designation,
        vat_no,
        retailer_email,
        phone_number,
        address,
        total_discount,
        customer_discount,
        incentive,
        contact_person,
        region,
        referral_token,
        // designation,
        store_discount,
        contact_name,
        store,
        retailer_password,
      });
      let storeCountry = storeCountryData;
      storeCountry.push({ countryCode: "", states: [], cities: [] });
      setStoreCountryData(storeCountry);
    }
  };

  const onClickRemove = (values, setValues) => {
    const store = [...values.store];
    store.pop();
    setValues({ ...values, store });
    let storeCountry = storeCountryData;
    storeCountry.push();
    setStoreCountryData(storeCountry);
  };

  const keyUp = (e) => {
    retailerService.check_store_email().then((res) => {
      if (res.status) {
      } else {
      }
    });
  };
  const checkRefferalToken = async (reffToken) => {
    let result = await retailerService.checkRefferalTokenApi({
      referral_token: reffToken,
    });
    if (result.status === true) {
      return "Already Exist";
    }
  };

  const onCountryChange = (e, name, setFieldValue) => {
    if (name === "country") {
      setStates(csc.getStatesOfCountry(e.isoCode));
      setCountryCode(e.isoCode);
    } else if (name === "state") {
      setCities(csc.getCitiesOfState(countryCode, e.isoCode));
    }
    setFieldValue([name], e.value);
  };

  const onStoreCountryChange = (e, name, setFieldValue, values, key) => {
    let data = storeCountryData;
    let fieldData = values.store;
    if (name === "country") {
      data[key].states = csc.getStatesOfCountry(e.isoCode);
      data[key].countryCode = e.isoCode;
      setStoreCountryData(data);
    } else if (name === "state") {
      data[key].cities = csc.getCitiesOfState(data[key].countryCode, e.isoCode);
      setStoreCountryData(data);
    }
    fieldData[key][name] = e.value;
    setFieldValue("store", fieldData);
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                errors,
                values,
                touched,
                setValues,
                setFieldValue,
                getFieldProps,
                setFieldError,
              }) => (
                console.log(values, "values"),
                console.log(errors, "errors"),
                (
                  <Form className="control-form" autoComplete="off">
                    <div className="row">
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          Retailer/Corporate/Markelplace Type
                        </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.type
                                ? !errors.type
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          name="type"
                          // isOptionDisabled={(option) => option.isdisabled}
                          onChange={(e) =>
                            onSelect(e, values, setValues, "type")
                          }
                          options={[
                            { value: "retailer", label: "Retailer" },
                            { value: "corporate", label: "Corporate" },
                            { value: "marketplace", label: "Marketplace" },
                          ]}
                        />
                        {touched.type && errors.type ? (
                          <div className="text-danger">{errors.type}</div>
                        ) : null}
                      </div>
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          Retailer/Corporate/Markelplace Name
                        </label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.retailer_name && errors.retailer_name
                              ? " is-invalid"
                              : "")
                          }
                          name="retailer_name"
                          placeholder="Enter Retailer Name"
                        />
                        {touched.retailer_name && errors.retailer_name ? (
                          <div className="text-danger">
                            {errors.retailer_name}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-6">
                        <div className="form-group">
                          <label className="form-label">Contact No.</label>
                          {/* <div className="input-group">
													<Field
														type="number"
														className={
														"form-control" +
														(touched.phone_number && errors.phone_number
															? " is-invalid"
															: "")
														}
														name="phone_number"
														placeholder="Enter Contact Number"
													/>
													</div> */}
                          <div
                            className={
                              touched.phone_number
                                ? !errors.phone_number
                                  ? " contact-success"
                                  : " contact-error"
                                : ""
                            }
                          >
                            <PhoneCode
                              Addphone={(value) =>
                                setValues({ ...values, phone_number: value })
                              }
                              phone={values.phone_number}
                            />
                          </div>
                        </div>
                        {touched.phone_number && errors.phone_number ? (
                          <div className="text-danger">
                            {errors.phone_number}
                          </div>
                        ) : null}
                      </div>
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          Retailer/Corporate/Markelplace Category
                        </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.retailer_type
                                ? !errors.retailer_type
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          name="retailer_type"
                          // isOptionDisabled={(option) => option.isdisabled}
                          onChange={(e) =>
                            onSelect(e, values, setValues, "retailer_type")
                          }
                          options={retailerTypeList}
                        />
                        {touched.retailer_type && errors.retailer_type ? (
                          <div className="text-danger">
                            {errors.retailer_type}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-6">
                        <label className="form-label">Address</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.address && errors.address
                              ? " is-invalid"
                              : "")
                          }
                          name="address"
                          placeholder="Enter Address"
                        />
                        {touched.address && errors.address ? (
                          <div className="text-danger">{errors.address}</div>
                        ) : null}
                      </div>
                      {/* country  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">Country </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.country
                                ? !errors.country
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          onChange={(e) =>
                            onCountryChange(e, "country", setFieldValue)
                          }
                          options={helperFunction.convertToSelectList(
                            country,
                            "name",
                            "name"
                          )}
                        />
                        {touched.country && errors.country ? (
                          <div className="text-danger">{errors.country}</div>
                        ) : null}
                      </div>
                      {/* state  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">State </label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.state
                                ? !errors.state
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          onChange={(e) =>
                            onCountryChange(e, "state", setFieldValue)
                          }
                          options={helperFunction.convertToSelectList(
                            states,
                            "name",
                            "name"
                          )}
                        />
                        {touched.state && errors.state ? (
                          <div className="text-danger">{errors.state}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-6">
                        <label className="form-label">W2D Sales Person</label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.contact_name
                                ? !errors.contact_name
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          options={customerServiceList}
                          onChange={(e) => {
                            onSelect(
                              { value: e.employee_name },
                              values,
                              setValues,
                              "contact_name"
                            );
                          }}
                          // to get value on referral change
                          // if (item?.employee_name === values?.contact_name) {
                          //   return item;
                          // }
                          value={customerServiceList.find(
                            (item) =>
                              item?.employee_name === values?.contact_name
                          )}
                        />
                        {/* <Field
												type="text"
												className={
													"form-control" +
													(touched.sales_person && errors.sales_person
														? " is-invalid"
														: "")
												}
												name="sales_person"
												placeholder="Enter Contact Name"
											/> */}
                        {touched.contact_name && errors.contact_name ? (
                          <div className="text-danger">
                            {errors.contact_name}
                          </div>
                        ) : null}
                      </div>
                      {/* city  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">City</label>
                        <Select
                          styles={{
                            valueContainer: (provided) => ({
                              ...provided,
                              height: "calc(2.15rem + 2px)",
                              overflowY: "visible",
                            }),
                            control: (provider) => ({
                              ...provider,
                              borderColor: touched.city
                                ? !errors.city
                                  ? "#34c38f"
                                  : "#f46a6a"
                                : "#ced4da",
                              boxShadow: "0 0 0 0px #f46a6a",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              color: "#a0b0ca",
                            }),
                          }}
                          onChange={(e) => setFieldValue("city", e.value)}
                          options={helperFunction.convertToSelectList(
                            cities,
                            "name",
                            "name"
                          )}
                        />
                        {touched.city && errors.city ? (
                          <div className="text-danger">{errors.city}</div>
                        ) : null}
                      </div>

                      {/* postal code  */}
                      <div className="mb-3 col-3">
                        <label className="form-label">Postal Code</label>
                        <input
                          type="text"
                          className={"form-control"}
                          {...getFieldProps("postal_code")}
                          placeholder="Enter Postal Code"
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-6">
                        <label className="form-label">Email ID</label>
                        <Field
                          type="email"
                          className={
                            "form-control" +
                            (touched.retailer_email && errors.retailer_email
                              ? " is-invalid"
                              : "")
                          }
                          name="retailer_email"
                          placeholder="Enter Email ID"
                          autoComplete="off"
                        />
                        {touched.retailer_email && errors.retailer_email ? (
                          <div className="text-danger">
                            {errors.retailer_email}
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-3 col-6">
                        <label className="form-label"> Password</label>
                        <div className="d-flex">
                          <Field
                            type={togglePassword ? "text" : "password"}
                            className={
                              "form-control no-border-right no-border-left" +
                              (touched.retailer_password &&
                              errors.retailer_password
                                ? " is-invalid"
                                : "")
                            }
                            name="retailer_password"
                            placeholder="Enter Password"
                            autoComplete="new-password"
                          />
                          <button
                            type="button"
                            className="btn-primary"
                            onClick={() => setTogglePassword(!togglePassword)}
                          >
                            {togglePassword ? <FaEye /> : <FaEyeSlash />}
                          </button>

                          {/* <FaEye /> */}
                        </div>
                        {touched.retailer_password &&
                        errors.retailer_password ? (
                          <div className="text-danger">
                            {errors.retailer_password}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          REGION: LOCAL / OVERSEAS
                        </label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.region && errors.region
                              ? " is-invalid"
                              : "")
                          }
                          name="region"
                          placeholder="Enter region"
                        />
                        {touched.region && errors.region ? (
                          <div className="text-danger">{errors.region}</div>
                        ) : null}
                      </div>
                      <div className="mb-3 col-6">
                        <label className="form-label">
                          VAT/TAX NUMBER: (ONLY FOR LOCAL PARTY)
                        </label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.vat_no && errors.vat_no
                              ? " is-invalid"
                              : "")
                          }
                          name="vat_no"
                          placeholder="Enter Vat No"
                        />
                        {touched.vat_no && errors.vat_no ? (
                          <div className="text-danger">{errors.vat_no}</div>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="mb-3 col-6">
                        <label className="form-label">Designation</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.designation && errors.designation
                              ? " is-invalid"
                              : "")
                          }
                          name="designation"
                          placeholder="Enter Sales Person"
                        />
                        {touched.designation && errors.designation ? (
                          <div className="text-danger">
                            {errors.designation}
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-3 col-6">
                        <label className="form-label">Sales Person</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.sales_person && errors.sales_person
                              ? " is-invalid"
                              : "")
                          }
                          name="sales_person"
                          placeholder="Enter Sales Person"
                        />
                        {touched.sales_person && errors.sales_person ? (
                          <div className="text-danger">
                            {errors.sales_person}
                          </div>
                        ) : null}
                      </div>

                      <div className="mb-3 col-6">
                        <label className="form-label">REFERAL CODE</label>
                        <Field
                          type="text"
                          className={
                            "form-control" +
                            (touched.referral_token && errors.referral_token
                              ? " is-invalid"
                              : "")
                          }
                          name="referral_token"
                          //value={values.checkRefferalToken}
                          placeholder="Enter Referral Token"
                          validate={checkRefferalToken}
                          // onKeyUp={(e) =>
                          // 	checkRefferalToken(e.target.value)
                          // }
                        />
                        {touched.referral_token && errors.referral_token ? (
                          <div className="text-danger">
                            {errors.referral_token}
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* <div className="row">
											<div className="mb-3 col-6">
											<label className="form-label">Incentive</label>
											<Field
												type="number"
												className={
													"form-control" +
													(touched.incentive
														&& errors.incentive
														? " is-invalid"
														: ""
														)
													}
												name="incentive"
												placeholder="Enter Incentive"
											/>
											{touched.incentive && errors.incentive ? (
												<div className="text-danger">{errors.incentive}</div>
											) : null}
											</div>
											<div className="mb-3 col-6">
											<label className="form-label">Contact Person</label>
											<Field
												type="text"
												className={
													"form-control" +
													(touched.contact_person
														&& errors.contact_person
														? " is-invalid"
														: ""
														)
													}
												name="contact_person"
												placeholder="Enter Contact Person"
											/>
											{touched.contact_person && errors.contact_person ? (
												<div className="text-danger">
												{errors.contact_person}
												</div>
											) : null}
											</div>
										</div> */}

                    {(values.type === "marketplace" && (
                      <div className="row">
                        {/* <div className="mb-3 col-6">
                      <label className="form-label">Profit Margin</label>
                      <Select
                       styles={{
                          valueContainer: (provided) => ({
                            ...provided,
                            height: "calc(2.15rem + 2px)",
                            overflowY: "visible",
                          }),
                          control: (provider) => ({
                            ...provider,
                            borderColor: touched.profit_margin
                              ? !errors.profit_margin
                                ? "#34c38f"
                                : "#f46a6a"
                              : "#ced4da",
                            boxShadow: "0 0 0 0px #f46a6a",
                          }),
                          placeholder: (provider) => ({
                            ...provider,
                            color: "#a0b0ca",
                          }),
                        }}
                        value={values.profit_margin}
                        name="profit_margin"
                        // isOptionDisabled={(option) => option.isdisabled}
                        onChange={(e) => onSelect(e, values, setValues, "profit_margin")}
                        options={[
                          { value: "freight", label: "Freight" },
                          { value: "profitability_segment", label: "Profitability Segment" },
                        ]}
                      />
                      {touched.profit_margin && errors.profit_margin ? (
                        <div className="text-danger">
                          {errors.profit_margin}
                        </div>
                      ) : null}
                    </div> */}
                        <div className="mb-3 col-6">
                          <label className="form-label">Profit Margin</label>
                          <Select
                            styles={{
                              valueContainer: (provided) => ({
                                ...provided,
                                height: "calc(2.15rem + 2px)",
                                overflowY: "visible",
                              }),
                              control: (provider) => ({
                                ...provider,
                                borderColor: touched.profit_margin
                                  ? !errors.profit_margin
                                    ? "#34c38f"
                                    : "#f46a6a"
                                  : "#ced4da",
                                boxShadow: "0 0 0 0px #f46a6a",
                              }),
                              placeholder: (provider) => ({
                                ...provider,
                                color: "#a0b0ca",
                              }),
                            }}
                            value={
                              values.profit_margin
                                ? {
                                    value: values.profit_margin,
                                    label: capitalizeFirstLetter(
                                      values.profit_margin.replace(/_/g, " ")
                                    ),
                                  }
                                : null
                            }
                            name="profit_margin"
                            onChange={(e) =>
                              onSelect(e, values, setValues, "profit_margin")
                            }
                            options={[
                              { value: "freight", label: "Freight" },
                              {
                                value: "profitability_segment",
                                label: "Profitability Segment",
                              },
                            ]}
                          />
                          {touched.profit_margin && errors.profit_margin ? (
                            <div className="text-danger">
                              {errors.profit_margin}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )) || (
                      <div className="row">
                        <div className="mb-3 col-4">
                          <label className="form-label">Total Discount</label>
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.total_discount && errors.total_discount
                                ? " is-invalid"
                                : "")
                            }
                            name="total_discount"
                            placeholder="Enter Total Discount"
                          />
                          {touched.total_discount && errors.total_discount ? (
                            <div className="text-danger">
                              {errors.total_discount}
                            </div>
                          ) : null}
                        </div>

                        <div className="mb-3 col-4">
                          <label className="form-label">
                            Customer Discount
                          </label>
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.customer_discount &&
                              errors.customer_discount
                                ? " is-invalid"
                                : "")
                            }
                            name="customer_discount"
                            placeholder="Enter Discount To Customer"
                          />
                          {touched.customer_discount &&
                          errors.customer_discount ? (
                            <div className="text-danger">
                              {errors.customer_discount}
                            </div>
                          ) : null}
                        </div>

                        <div className="mb-3 col-4">
                          <label className="form-label">Store Discount</label>
                          <Field
                            type="number"
                            className={
                              "form-control" +
                              (touched.store_discount && errors.store_discount
                                ? " is-invalid"
                                : "")
                            }
                            name="store_discount"
                            placeholder="Enter Discount To Store"
                          />
                          {touched.store_discount && errors.store_discount ? (
                            <div className="text-danger">
                              {errors.store_discount}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )}

                    <FieldArray name="store">
                      {() =>
                        values.store.map((item, key) => {
                          const storeError =
                            (errors.store?.length && errors.store[key]) || {};

                          const storeTouched =
                            (touched.store?.length && touched.store[key]) || {};

                          return (
                            <div className="border p-2 my-2">
                              <div className="row">
                                <div className="mb-3 col-6">
                                  <label className="form-label">
                                    Store Name
                                  </label>
                                  <Field
                                    type="text"
                                    name={`store.${key}.store_name`}
                                    className={
                                      "form-control " +
                                      (storeError.store_name &&
                                      storeTouched.store_name
                                        ? " is-invalid"
                                        : "")
                                    }
                                    value={item.store_name}
                                    placeholder="Enter Name"
                                  />
                                </div>
                                <div className="mb-3 col-6">
                                  <div className="form-group">
                                    <label className="form-label">
                                      Contact No.
                                    </label>
                                    <div className="input-group">
                                      <Field
                                        type="number"
                                        className={
                                          "form-control" +
                                          (storeError.phone_number &&
                                          storeTouched.phone_number
                                            ? " is-invalid"
                                            : "")
                                        }
                                        name={`store.${key}.phone_number`}
                                        value={item.phone_number}
                                        placeholder="Enter Contact Number"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="mb-3 col-6">
                                  <label className="form-label">
                                    Store Email{" "}
                                  </label>
                                  <Field
                                    type="email"
                                    className={
                                      "form-control" +
                                      (storeError.store_email &&
                                      storeTouched.store_email
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name={`store.${key}.store_email`}
                                    value={item.store_email}
                                    placeholder="Enter Email"
                                    onKeyUp={(e) => keyUp(e)}
                                  />
                                </div>
                                <div className="mb-3 col-6">
                                  <label className="form-label"> Address</label>
                                  <Field
                                    type="text"
                                    className={
                                      "form-control" +
                                      (storeError.address &&
                                      storeTouched.address
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name={`store.${key}.address`}
                                    value={item.address}
                                    placeholder="Enter Address"
                                  />
                                </div>

                                {/* country  */}
                                <div className="mb-3 col-3">
                                  <label className="form-label">Country </label>
                                  <Select
                                    styles={{
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        height: "calc(2.15rem + 2px)",
                                        overflowY: "visible",
                                      }),
                                      control: (provider) => ({
                                        ...provider,
                                        borderColor:
                                          touched?.store &&
                                          touched.store[key]?.country
                                            ? errors?.store &&
                                              !errors.store[key]?.country
                                              ? "#34c38f"
                                              : "#f46a6a"
                                            : "#ced4da",
                                        boxShadow: "0 0 0 0px #f46a6a",
                                      }),
                                      placeholder: (provider) => ({
                                        ...provider,
                                        color: "#a0b0ca",
                                      }),
                                    }}
                                    onChange={(e) =>
                                      onStoreCountryChange(
                                        e,
                                        "country",
                                        setFieldValue,
                                        values,
                                        key
                                      )
                                    }
                                    options={helperFunction.convertToSelectList(
                                      country,
                                      "name",
                                      "name"
                                    )}
                                  />
                                </div>
                                {/* state  */}
                                <div className="mb-3 col-3">
                                  <label className="form-label">State </label>
                                  <Select
                                    styles={{
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        height: "calc(2.15rem + 2px)",
                                        overflowY: "visible",
                                      }),
                                      control: (provider) => ({
                                        ...provider,
                                        borderColor:
                                          touched?.store &&
                                          touched.store[key]?.state
                                            ? errors?.state &&
                                              !errors.store[key]?.state
                                              ? "#34c38f"
                                              : "#f46a6a"
                                            : "#ced4da",
                                        boxShadow: "0 0 0 0px #f46a6a",
                                      }),
                                      placeholder: (provider) => ({
                                        ...provider,
                                        color: "#a0b0ca",
                                      }),
                                    }}
                                    onChange={(e) =>
                                      onStoreCountryChange(
                                        e,
                                        "state",
                                        setFieldValue,
                                        values,
                                        key
                                      )
                                    }
                                    options={helperFunction.convertToSelectList(
                                      storeCountryData[key].states,
                                      "name",
                                      "name"
                                    )}
                                  />
                                </div>
                                {/* city  */}
                                <div className="mb-3 col-3">
                                  <label className="form-label">City</label>
                                  <Select
                                    styles={{
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        height: "calc(2.15rem + 2px)",
                                        overflowY: "visible",
                                      }),
                                      control: (provider) => ({
                                        ...provider,
                                        borderColor:
                                          touched?.store &&
                                          touched.store[key]?.city
                                            ? errors?.city &&
                                              !errors.store[key]?.city
                                              ? "#34c38f"
                                              : "#f46a6a"
                                            : "#ced4da",
                                        boxShadow: "0 0 0 0px #f46a6a",
                                      }),
                                      placeholder: (provider) => ({
                                        ...provider,
                                        color: "#a0b0ca",
                                      }),
                                    }}
                                    onChange={(e) =>
                                      onStoreCountryChange(
                                        e,
                                        "city",
                                        setFieldValue,
                                        values,
                                        key
                                      )
                                    }
                                    options={helperFunction.convertToSelectList(
                                      storeCountryData[key].cities,
                                      "name",
                                      "name"
                                    )}
                                  />
                                </div>
                                {/* postal code  */}
                                <div className="mb-3 col-3">
                                  <label className="form-label">
                                    Postal Code
                                  </label>
                                  <Field
                                    type="number"
                                    className={
                                      "form-control" +
                                      (storeError.postal_code &&
                                      storeTouched.postal_code
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name={`store.${key}.postal_code`}
                                    value={item.postal_code}
                                    // {...getFieldProps("postal_code")}
                                    placeholder="Enter Postal Code"
                                  />
                                </div>

                                <div className="mb-3 col-6">
                                  <label className="form-label">
                                    Contact Person
                                  </label>
                                  <Field
                                    type="text"
                                    className={
                                      "form-control" +
                                      (storeError.contact_person &&
                                      storeTouched.contact_person
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name={`store.${key}.contact_person`}
                                    value={item.contact_person}
                                    placeholder="Enter Address"
                                  />
                                </div>
                                <div className="mb-3 col-6">
                                  <label className="form-label">
                                    Designation
                                  </label>
                                  <Field
                                    type="text"
                                    className={
                                      "form-control" +
                                      (storeError.store_designation &&
                                      storeTouched.store_designation
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name={`store.${key}.store_designation`}
                                    value={item.store_designation}
                                    placeholder="Enter Designation"
                                  />
                                </div>
                                <div className="mb-3 col-6">
                                  <label className="form-label">
                                    Store Password
                                  </label>
                                  <div className="d-flex">
                                    <Field
                                      type={
                                        toggleStorePassword
                                          ? "text"
                                          : "password"
                                      }
                                      className={
                                        "form-control no-border-right no-border-left" +
                                        (storeError.store_password &&
                                        storeTouched.store_password
                                          ? " is-invalid"
                                          : "")
                                      }
                                      name={`store.${key}.store_password`}
                                      value={item.store_password}
                                      placeholder="Enter Password"
                                    />
                                    <button
                                      type="button"
                                      className="btn-primary"
                                      onClick={() =>
                                        setToggleStorePassword(
                                          !toggleStorePassword
                                        )
                                      }
                                    >
                                      {toggleStorePassword ? (
                                        <FaEye />
                                      ) : (
                                        <FaEyeSlash />
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      }
                    </FieldArray>

                    <div className="d-flex justify-content-start">
                      {values.store.length >= 1 && (
                        <button
                          className="btn btn-sm btn-secondary me-2"
                          type="button"
                          onClick={() => onClickRemove(values, setValues)}
                        >
                          {" "}
                          - Remove
                        </button>
                      )}
                      {values.type !== "marketplace" && (
                        <button
                          className="btn btn-sm btn-info"
                          type="button"
                          onClick={() => addStore(errors, values, setValues)}
                        >
                          {" "}
                          + Add Store Details
                        </button>
                      )}
                    </div>

                    <div className="mt-3 d-flex justify-content-between">
                      <button
                        className="btn btn-danger w-sm waves-effect waves-light"
                        type="button"
                        onClick={() => history.goBack()}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-primary w-sm waves-effect waves-light"
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )
              )}
            </Formik>

            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
